module.exports = "https://sf6-scmcdn2-tos.pstatp.com/motor/pc/_next/static/images/dongchedi-logo-db4472fc50bcddce0766b6de60aec985.svg";